.getMyPlanBlock {
  padding: 0 20px 0;
  position: relative;
}

.label {
  position: absolute;
  top: -13px;
  right: 62px;
  width: 53px;
  height: 53px;
  min-width: 53px;
  min-height: 53px;
  z-index: 1;
  background: url('./img/label.png') no-repeat center center;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: rotate(14deg);

  p:first-child {
    font-size: 13.815px;
  }

  p:last-child {
    margin-right: 3px;
  }

  p {
    color: #FFFBF1;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 11.512px;
    font-weight: 900;
    line-height: 11.512px;
    letter-spacing: -0.345px;
  }
}

.description {
  margin-top: 16px;
  color: #7B766F;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -0.3px;
  // opacity: 0.5;

  a {
    text-decoration: underline;
  }

  b {
    font-weight: 900;
  }
}

.getMyPlanBlock.tariffV5 {
  .description {
    color: #FFFBF1;
  }
}